import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=a032da4c&scoped=true&"
import script from "./Story.vue?vue&type=script&lang=ts&"
export * from "./Story.vue?vue&type=script&lang=ts&"
import style0 from "./Story.vue?vue&type=style&index=0&id=a032da4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a032da4c",
  null
  
)

export default component.exports